<template>
  <div class="topfans-page-case">
    <div class="topfans-section app-basic-layout-wrapper">
      <h3 class="title font-30 font-color-white">应用案例</h3>
      <p class="subtitle font-color-white">
        查看其他商家如何通过粉丝头条取得成功
      </p>
      <div class="body">
        <swiper :options="swiperOptions">
          <swiper-slide>
            <img src="@/assets/img/topfans/case_slide_1.png" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="@/assets/img/topfans/case_slide_2.png" alt="" />
          </swiper-slide>
          <div slot="button-prev" class="swiper-button-prev">
            <i class="iconfont icon-zuocefanhuijiantou"></i>
          </div>
          <div slot="button-next" class="swiper-button-next">
            <i class="iconfont icon-youcefanhuijiantou"></i>
          </div>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'topfans-page-case',
  data() {
    return {
      swiperOptions: {
        spaceBetween: 16,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        scrollbar: {
          el: '.swiper-scrollbar'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.topfans-page-case {
  background: url('~@/assets/img/topfans/case_bg.png') repeat center/cover;
  .topfans-section {
    & > .title {
      &:after {
        background-color: #ffffff;
      }
    }
    & > .subtitle {
      margin-bottom: 60px;
    }
  }
  .swiper-slide {
    padding-bottom: 56px;
    img {
      width: 100%;
    }
  }
  .swiper-scrollbar {
    width: 432px;
    height: 3px;
    left: 50%;
    bottom: 16px;
    margin-left: -216px;
    background-color: rgba(255, 255, 255, 0.1);
    &::v-deep .swiper-scrollbar-drag {
      background-color: #ffffff;
    }
  }
  .swiper-button-next,
  .swiper-button-prev {
    background-color: rgba(255, 255, 255, 0.15);
    width: 32px;
    height: 32px;
    line-height: 32px;
    background-image: none;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #ffffff;
    top: auto;
    bottom: 0;
    &:hover {
      background-color: $danger-color;
      color: #ffffff;
    }
    &.swiper-button-disabled {
      opacity: 0.65;
      background-color: rgba(255, 255, 255, 0.15);
      color: rgba(255, 255, 255, 0.35);
    }
  }
  .swiper-button-next {
    right: 0;
  }
  .swiper-button-prev {
    right: 44px;
    left: auto;
  }
}
</style>
